import { render, staticRenderFns } from "./PaRateCardTable.vue?vue&type=template&id=2aeb8b9c&scoped=true"
import script from "./PaRateCardTable.vue?vue&type=script&lang=js"
export * from "./PaRateCardTable.vue?vue&type=script&lang=js"
import style0 from "./PaRateCardTable.vue?vue&type=style&index=0&id=2aeb8b9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aeb8b9c",
  null
  
)

export default component.exports